import $ from 'jquery';
import CFDynamicMenu from './CFDynamicMenu';
import info from './info';

const NAMESPACE = 'CFDynamicMenu';
const OtherCFDynamicMenu = $.fn.CFDynamicMenu;

const jQueryCFDynamicMenu = function initJQueryCFDynamicMenu(options, ...args) {
  if (typeof options === 'string') {
    const method = options;

    if (/^_/.test(method)) {
      return false;
    } else if ((/^(get)/.test(method))) {
      const instance = this.first().data(NAMESPACE);
      if (instance && typeof instance[method] === 'function') {
        return instance[method](...args);
      }
    } else {
      return this.each(function callCFDynamicMenuInstance() {
        const instance = $.data(this, NAMESPACE);
        if (instance && typeof instance[method] === 'function') {
          instance[method](...args);
        }
      });
    }
  }

  return this.each(function initCFDynamicMenu() {
    if (!$(this).data(NAMESPACE)) {
      $(this).data(NAMESPACE, new CFDynamicMenu(this, options));
    }
  });
};

$.fn.CFDynamicMenu = jQueryCFDynamicMenu;

$.CFDynamicMenu = $.extend({
  setDefaults: CFDynamicMenu.setDefaults,
  noConflict: function noConflict() {
    $.fn.CFDynamicMenu = OtherCFDynamicMenu;
    return jQueryCFDynamicMenu;
  },
}, info);



// WEBPACK FOOTER //
// ./assets/js/cf-dynamic-menu/main.js